<div class="flat-area-wrapper">

  <div class="selected-flat-area">

    <div class="row">
      <div class="col-4">
        <app-flat-area-type-selector [flatArea]="selectedFlatArea"></app-flat-area-type-selector>
      </div>
      <div class="col-4">
        <app-flat-coverage-selector [flatArea]="selectedFlatArea"></app-flat-coverage-selector>
      </div>
      <div class="col-3">
        <mat-form-field>

          <input matInput
                 type="number"
                 placeholder="{{'FLAT.AREA.SIZE' | translate}}"
                 [(ngModel)]="selectedFlatArea.size">

        </mat-form-field>
      </div>

      <div class="col-1">
        <button [disabled]="!isFormValid()" class="add-or-edit-button" mat-mini-fab color="primary"
                (click)="addOrEditSelectedFlatArea()">
          <mat-icon matSuffix>{{'add'}}</mat-icon>
        </button>

      </div>
    </div>

  </div>

  <div class="flat-areas" cdkDropList (cdkDropListDropped)="drop($event)">
    <div *ngFor="let flatArea of flatAreas; let i = index" cdkDrag class="row flat-area-item"
         [class.selected]="flatArea.flatAreaId === selectedFlatArea.flatAreaId"
         (click)="selectItem(flatArea)">
      <div class="col-1">{{i + 1}}</div>
      <div class="col-1 drag-handler-wrapper">
        <div class="drag-handler" cdkDragHandle>
          <svg width="24px"  viewBox="0 0 24 24">
            <path
              d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>
      </div>
      <div class="col-3">{{flatArea.name}}</div>
      <div class="col-3">{{flatArea.coverage}}</div>
      <div class="col-3">{{flatArea.size}}</div>

      <div class="col-1 delete-icon">
        <mat-icon class="dark" (click)="deleteItem(flatArea)">delete</mat-icon>
      </div>
    </div>

  </div>

</div>
